const Joi = require('@hapi/joi');
import Vue from 'vue';

Vue.prototype.$joi = Joi

export default {

    data(){
        return {

        }
    },

    computed:{
        user(){
            return this.$store.state.currentUser
        }
    },

    methods: {
        async sendRequest(type,endpoint,data){
            this.$axios.defaults.headers.common["X-Access-Token"] = this.$store.state.accessToken;
            try{
                let req = null
                if(type=="get"){
                    req = await this.$axios[type](endpoint)
                } 
                else{
                    req = await this.$axios[type](endpoint,data)
                }
                if(req && req.data && req.data.message && req.data.message == "INVALID_TOKEN"){
                    localStorage.removeItem('user')
                    this.$router.push({name:"login"})
                }
                delete this.$axios.defaults.headers.common["X-Access-Token"];
                return req
            }
            catch(err){
                delete this.$axios.defaults.headers.common["X-Access-Token"];
                return err
            }
        },
        setToken(token) {
            this.$store.state.accessToken = token;
            // this.$Cookies.set("X-Access-Token", token, { expires: 30 });
            localStorage.setItem('token', token)
        },
        checkToken() {
            // if we have a token
            console.log("Check Token")
            if (localStorage.getItem('token') != null && localStorage.getItem('token').length > 0) {
                
                // set cookies in axios
                this.$store.state.accessToken = localStorage.getItem('token');
                return true;

            } 
            else {
                // redirect to login
                this.$router.push({name:'login'});
                return false;

            }
        },
    }
};